import React, { useState, useEffect, useRef } from 'react';

import SearchSuggestions from '../search-suggestions/SearchSuggestions';

import { SearchField, SearchContainer, SearchIcon } from './Search.styles';
import { FiSearch } from 'react-icons/fi';

const Search = ({ searchOpen, setSearchOpen }) => {
  const [searchValue, setSearchValue] = useState('');
  const [searchData, setSearchData] = useState({});
  const handleChange = e => {
    const { value } = e.target;
    setSearchValue(value);
    // Clear search data if user wants to make a new search
    if (!value) setSearchData({});
  };
  // Timeout to delay API call if user is still typing
  const timeout = useRef(null);
  useEffect(() => {
    if (!searchValue) return;
    if (timeout.current) {
      clearTimeout(timeout.current);
    }
    timeout.current = setTimeout(() => {
      const url = `/.netlify/functions/listennotes?url=typeahead?q=${encodeURIComponent(
        searchValue
      )}&show_podcasts=1`;
      fetch(url)
        .then(res => res.json())
        .then(data => setSearchData(data))
        .catch(err => console.error(err));
    }, 500);
  }, [searchValue]);

  return (
    <SearchContainer searchOpen={searchOpen}>
      <SearchField
        type="text"
        placeholder="Search shows"
        value={searchValue}
        onChange={handleChange}
      />
      <SearchIcon>
        <FiSearch />
      </SearchIcon>
      {searchValue &&
        searchData.hasOwnProperty('podcasts') &&
        searchData.podcasts.length > 0 && (
          <SearchSuggestions
            setSearchOpen={setSearchOpen}
            results={searchData.podcasts}
            clearForm={setSearchValue}
          />
        )}
    </SearchContainer>
  );
};

export default Search;
